import { render } from "./LogBoletosRegistros.vue?vue&type=template&id=1b17a598&scoped=true"
import script from "./LogBoletosRegistros.vue?vue&type=script&lang=js"
export * from "./LogBoletosRegistros.vue?vue&type=script&lang=js"

import "./LogBoletosRegistros.vue?vue&type=style&index=0&id=1b17a598&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b17a598"]])

export default __exports__